import React from 'react';
import GameAssetsContainer from './GameAssetsContainer';

const GameAssetsView = () => {
  return <GameAssetsContainer />;
};

export default GameAssetsView;
